/**
 * @file style
 * @author Yu Zong(liuxuanzy@qq.com)
 */
import { toBoolean } from '@tencent/glue-util-helper';
import { PARENT_WIDTH_PROPS, PARENT_HEIGHT_PROPS, PERCENT_SIZE_PROPS, FIXED_SIZE_PROPS, TRANSFORM_PROPS, ANIMATION_PROPS, ROTATE_PROPS, } from '../const/style';
export var isParentWidthProp = toBoolean(PARENT_WIDTH_PROPS);
export var isParentHeightProp = toBoolean(PARENT_HEIGHT_PROPS);
export var isPercentProp = toBoolean(PERCENT_SIZE_PROPS);
export var isFixProp = toBoolean(FIXED_SIZE_PROPS);
export var isTransformProp = toBoolean(TRANSFORM_PROPS);
export var isRotateProps = toBoolean(ROTATE_PROPS);
export var isAnimationProp = toBoolean(ANIMATION_PROPS);
